import { MagentoProduct } from './magento-product';

export interface MagentoProducts {
  items: MagentoProduct[];
}
